module.exports = __webpack_public_path__ + "static/media/nfh.28870a05.apk";